export default __webpack_public_path__ + "static/media/slots-hover.0b9e1da5.webp";